import type { Ref } from 'vue';

export function useStickyHeight(elements: Ref<HTMLElement | null>[]) {
  let observer: ResizeObserver | null = null;
  let stop: (() => void) | null = null;

  const setHeight = (el: HTMLElement) => {
    el.style.setProperty('--sticky-height', `${Math.ceil(el.scrollHeight)}px`);
  };

  onMounted(() => {
    observer = new ResizeObserver((entries) =>
      entries.forEach((entry) => setHeight(entry.target as HTMLElement)),
    );

    stop = watch(
      elements,
      (els, prev) => {
        prev?.forEach((el) => el && observer?.unobserve(el));
        els.forEach((el) => {
          if (el) {
            observer?.observe(el);
            setHeight(el);
          }
        });
      },
      { immediate: true, flush: 'post' },
    );
  });

  onBeforeUnmount(() => {
    stop?.();
    observer?.disconnect();
  });
}
